import { render } from "./PortfolioView.vue?vue&type=template&id=345565d6&scoped=true"
import script from "./PortfolioView.vue?vue&type=script&lang=js"
export * from "./PortfolioView.vue?vue&type=script&lang=js"

import "./PortfolioView.vue?vue&type=style&index=0&id=345565d6&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3459830904/src/personalwebsite2022/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-345565d6"]])

export default __exports__